import React, { useEffect, useState } from 'react';
import { useLingui } from '@lingui/react/macro';

interface CountdownProps {
    lockTimeEndUtc: string;
    onExpire?: () => void;
}

export const Countdown: React.FC<CountdownProps> = ({ lockTimeEndUtc, onExpire }) => {
    const [timeLeftSec, setTimeLeftSec] = useState(0);
    const { t } = useLingui();
    const MINUTES = t`minutes`;
    const SECONDS = t`seconds`;

    useEffect(() => {
        if (!lockTimeEndUtc) return;
        const endTs = new Date(lockTimeEndUtc).getTime();

        const tick = () => {
            const secs = Math.max(0, Math.floor((endTs - Date.now()) / 1000));
            setTimeLeftSec(secs);
            if (secs === 0 && onExpire) {
                onExpire();
            }
        };

        tick();
        const id = window.setInterval(tick, 1000);
        return () => window.clearInterval(id);
    }, [lockTimeEndUtc, onExpire]);

    const mm = String(Math.floor(timeLeftSec / 60)).padStart(2, '0');
    const ss = String(timeLeftSec % 60).padStart(2, '0');

    return (
        <span>
            {mm}:{ss} {parseInt(mm, 10) >= 1 ? MINUTES : timeLeftSec > 0 ? SECONDS : ''}
        </span>
    );
};
